import { Component, EventEmitter, inject, Input, OnInit, Output, signal } from '@angular/core';
import { Router } from '@angular/router';
import { TokenService } from '@processo/services/token.service';
import { setDefaultProcessToState } from '@processo/shared/state/appstate.logic';
import { AppstateService } from '@processo/shared/state/appstate.service';
import { StateService } from '@processo/shared/state/state.service';
import { GlobalFilterService } from '@processo/services/global-filter.service';
import { OrgDashboardService } from '@processo/shared/organization/dashboard/org-dashboard.service';
import { combineLatest } from 'rxjs';

@Component({
    selector: 'app-header-menu',
    templateUrl: './header-menu.component.html',
    styleUrls: ['./header-menu.component.scss'],
    standalone: false
})
export class HeaderMenuComponent implements OnInit{
  firstName: string = '';
  lastName: string = '';
  fullName: string = '';
  public badgeCount:number = 20;
  @Input()routerData:any=signal(null);
  appStateService = inject(AppstateService);
  tokenService = inject(TokenService);
  router = inject(Router);
  stateService = inject(StateService);
  globalFilterService = inject(GlobalFilterService);
  orgDashboardService = inject(OrgDashboardService);
  orgList = this.appStateService.getOrgList
  selectedOrganization = this.appStateService.getCurrentOrganization;
  filteredOrgList=this.orgList()
  
  ngOnInit(): void {
    const userObj = this.stateService.isUserLoggedIn().userDetail.attributes;
    this.firstName = userObj?.first_name.charAt(0);
    this.lastName = userObj?.last_name.charAt(0);
    this.fullName = `${userObj?.first_name} ${userObj?.last_name}`;
  }

  async signOut() {
    let body = {
      refresh_token: this.tokenService?.getRefreshToken()
    }
    this.stateService.logout(body).subscribe((res) => {
      if (res) {
        this.stateService.clearState();
      }
    })
    try { this.globalFilterService.clear(); } catch {}
    try { this.orgDashboardService.resetState(); } catch {}
    try { sessionStorage.removeItem('savedDashboardFilters'); } catch {}
    try { sessionStorage.removeItem('lastFilterOrgId'); } catch {}
    try { sessionStorage.removeItem('current_dashboard_id'); } catch {}
    this.stateService.clearState();
    this.appStateService.resetAppState() 
  }

  setting(){
   let value ={
      route:this.router.url,
      from:'table'
     }
     this.appStateService.state_url_save.next(value)
    this.router.navigate(['/org',this.appStateService.getCurrentOrganization()?.org_name,'basic'])
  }

  filterorg(searchValue: any) {
    if (!searchValue) {
      this.filteredOrgList = this.orgList();
    } else {
      this.filteredOrgList = this.orgList()
        .filter((option: any) =>
          option.org_name.toLowerCase().includes(searchValue.toLowerCase())
        );
    }
  }

  async onOrganizationSelection(org:any){
    if (org.org_name === this.selectedOrganization()?.org_name) {
      return;
    }
    this.appStateService.clearImportFilter();
    try { this.globalFilterService.clear(); } catch {}
    try { await this.orgDashboardService.resetState(); } catch {}
    try { sessionStorage.removeItem('dbf::last'); } catch {}
    try { sessionStorage.removeItem('current_dashboard_id'); } catch {}
    
    this.appStateService.updateDefaultOrganization(org)
    await setDefaultProcessToState({appStateService:this.appStateService,stateService:this.stateService});
    
    const orgName = this.appStateService.getCurrentOrganization().router_org_value;
    const process = this.appStateService.getCurrentProcess();
    const processName = process.router_process_value;

    if (this.router.url.includes('/conversation')) {
      const payload = {
        org_id: org.org_id,
        process_id: process.process_id,
      };
      combineLatest([
        this.stateService.get_process_metadataNew(
          payload,
          process.process_name,
          process.org_process_id
        ),
        this.stateService.getLayoutMetadata(payload),
      ]).subscribe({
        next: (res: any) => {
          if (res) {
            this.appStateService.updateMetaDataAndLayout(
              res,
              orgName,
              processName
            );
            this.router.navigateByUrl(`/org/${orgName}/process/${processName}/conversation`);
          }
        },
      });
    } else {
      this.router.navigateByUrl(`/org/${orgName}/process/${processName}/view`);
    }
  }

  go_to(value:any){
    if(value === 'org'){
      this.router.navigateByUrl('org/list');
    }else if(value ==='profile'){
      this.router.navigateByUrl('user/settings')
    }else if(value === 'conversation'){
      this.go_to_conv();
    }
  }

  open_process_menu:boolean = false;
  open_menu(){
    this.open_process_menu = true;
  }
  close_menu(){
    this.open_process_menu = false;
  }

  get isConv(): boolean {
    return this.router.url.includes('/conversation');
  }

  side_bar_output(event:any){
    if(event === 'close'){
      this.close_menu()
    }
  }

  go_to_conv(){
    const currentOrg = this.appStateService.getCurrentOrganization();
    const currentProcess = this.appStateService.getCurrentProcess();
    
    if (currentOrg?.router_org_value && currentProcess?.router_process_value) {
      this.router.navigateByUrl(`/org/${currentOrg.router_org_value}/process/${currentProcess.router_process_value}/conversation`);
    } else {
      this.router.navigate(['/org/list']);
    }
  }
}
